export default __webpack_public_path__ + "static/media/1414.5f40753b.png";